import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=6f8b20fc&scoped=true"
import script from "./Finish.vue?vue&type=script&lang=js"
export * from "./Finish.vue?vue&type=script&lang=js"
import style0 from "./Finish.vue?vue&type=style&index=0&id=6f8b20fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b20fc",
  null
  
)

export default component.exports